export default __webpack_public_path__ + "static/media/feed.730a2e2b.png";